import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const OrdenTable = ({ ordenEmpaque, setData }) => {
  const handleShowVariedadEmpaque = (campo_index, variedad_index) => {
    let data = [...ordenEmpaque];
    data[campo_index].variedades[variedad_index].visible =
      !data[campo_index].variedades[variedad_index].visible;
    setData(data);
  };

  return (
    <div className="row">
      <div className="col">
        {ordenEmpaque.map((campo, campo_index) => (
          <div key={campo.id_campo} className="mb-4">
            <div
              style={{
                backgroundColor: "#F0F0F0 ",
                padding: "3px",
                borderRadius: "5px",
                borderBottom: "solid",
                borderBottomWidth: "3px",
                borderBottomColor: "black",
              }}
            >
              <h5>{campo.campo}</h5>
            </div>
            <br />
            {campo.variedades.map((variedad, variedad_index) => (
              <div key={variedad.id_variedad}>
                <div
                  className="mb-1"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <button
                      className="btn btn-primary btn-sm"
                      style={{ borderRadius: "100px" }}
                      onClick={() =>
                        handleShowVariedadEmpaque(campo_index, variedad_index)
                      }
                    >
                      {!variedad.visible ? (
                        <FontAwesomeIcon icon="fa-solid fa-plus" />
                      ) : (
                        <FontAwesomeIcon icon="fa-solid fa-minus" />
                      )}
                    </button>{" "}
                    <label>
                      {variedad.variedad}{" "}
                      {variedad.bicolor && (
                        <FontAwesomeIcon
                          icon="fas fa-project-diagram"
                          style={{ color: "#0d73a5" }}
                        />
                      )}
                    </label>
                  </div>
                  <div>
                    <label>Proyeccion: {variedad.proyeccion}</label>
                  </div>
                </div>
                {variedad.visible && (
                  <div>
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr style={{ fontSize: "12px" }}>
                            <th>N.Orden</th>
                            <th>Calibre</th>
                            <th>Og/Cv</th>
                            <th>Etiqueta</th>
                            <th>Peso</th>
                            <th>Envase</th>
                            <th>Cant.</th>
                            <th>Estiba</th>
                            <th>Cajas</th>
                            <th>Yegueres</th>
                            <th>Fumigar</th>
                            <th>País destino</th>
                            <th>Destino inmediato</th>
                            <th>Tarima</th>
                            <th>Tipo pedido</th>
                            <th>Prioridad</th>
                            <th>Bolsa/Clamshell</th>
                            <th>Observaciones</th>
                          </tr>
                        </thead>
                        <tbody>
                          {variedad.empaques.map((empaque) => (
                            <tr
                              key={empaque.id_empaque}
                              style={{ fontSize: "12px" }}
                              className={
                                empaque.prioridad === 1 && "table-primary"
                              }
                            >
                              <td>{empaque.id_empaque}</td>
                              <td>{empaque.calibre}</td>
                              <td>{empaque.og_cv}</td>
                              <td>{empaque.etiqueta}</td>
                              <td>{empaque.peso}</td>
                              <td>{empaque.envase}</td>
                              <td>
                                {renderLimite(
                                  empaque.resto,
                                  empaque.cantidad,
                                  empaque.extra,
                                  empaque.limite,
                                )}
                                {/* {empaque.resto
                                  ? `Libre - ${
                                      empaque.limite + " límite" ?? ""
                                    }`
                                  : empaque.cantidad}{" "}
                                {empaque.extra && " - Extra"} */}
                              </td>
                              <td>{empaque.estiba}</td>
                              <td>{empaque.resto ? "Libre" : empaque.cajas}</td>
                              <td>{empaque.yeguere}</td>
                              <td>{!empaque.fumigar ? "NO" : "SI"}</td>
                              <td>{empaque.pais_destino}</td>
                              <td>{empaque.destino_inmediato}</td>
                              <td>{empaque.tarima}</td>
                              <td>{empaque.tipo_pedido}</td>
                              <td>{empaque.prioridad === 0 ? "NO" : "SI"}</td>
                              <td>{empaque.bolsas_clams}</td>
                              <td>{empaque.observaciones}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

const renderLimite = (resto, cantidad, extra, limite) => {
  let text = `${cantidad}`;
  if (resto) {
    text = `Libre`;
    if (limite && limite > 0) {
      text += ` - ${limite} límite`;
    }
  }

  if (extra) {
    text = `${extra} - Extra`;
  }

  return text;
};
